var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"alert",class:_vm.colorClass,attrs:{"role":"alert"}},_vm._l((_vm.messages.entries()),function(ref){
var index = ref[0];
var message = ref[1];
return _c('div',{key:index},[_vm._v(" "+_vm._s(message)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }